import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { AppContext } from '../../App';

const Home = (props) => {
  const [user, setUser] = useState(false)
  const [courses, setCourses] = useState([]);
  const [myApplications, setMyApplications] = useState([]);
  const appContext = useContext(AppContext);

  useEffect(() => {

    appContext.httpClient.get({
      path: "user"
    }).then(response => {
      if (response.result) {
        console.log(response.result)
        setUser(response.result);
      }
    })

    appContext.httpClient.get({
      path: "course/published"
    }).then(response => {
        if (response.success && response.result) {
          const sortedCourses = [...response.result].sort((a, b) =>
            a.courseTitle.localeCompare(b.courseTitle)
          );   
          setCourses(sortedCourses);
          console.log(sortedCourses)
        } 
    });
    
    appContext.httpClient.get({
      path: "courseapplication/myapplications"
    }).then(response => {
        if (response.result) {         
          const sortedApplications = [...response.result].sort((a, b) =>
            a.courseTitle.localeCompare(b.courseTitle)
          );    
          setMyApplications(sortedApplications);
          console.log(sortedApplications)
        }
    });
  }, [appContext.apiBaseUrl]);

  const today = new Date();

  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const daysUntilCourseStarts = (startDate) => {
    const today = new Date();
    const start = new Date(startDate);
    const differenceInTime = start - today;
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24)); // Convert milliseconds to days
    return differenceInDays;
  };

  return (
    <div>
      {/* Hero */}
      <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <header className="section-header mt-auto mb-10">
            <h2 className="section-title text-4.5xl font-bold">Education</h2>
          </header>
          {/* Breadcrumbs */}
          <div className="breadcrumbs mb-4">
            <ul className="flex">
              <li><a className="white underline" href="/">Home</a></li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">Education</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex absolute top-0 left-0 right-0 bottom-0">
          <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
        </div>
      </section>

      <section className="py-8 lg:py-12">
        <header className="section__header">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
            <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Welcome to the Education pages on the INSOL International website</h1>
          </div>
        </header>
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
        <p className="text-brandMidBlue mb-4">On these pages you will find information relating to INSOL’s educational offerings and, where you have already enrolled to attend one of our courses, you will see the course and its relevant information under the heading “My courses” below (you will need to be logged in to view these).</p>
          {/*<span className="border border-brandMidBlue bg-brandGrey p-10 text-brandMidBlue mb-4" style={{ display: 'block' }}>
          Please note that INSOL International is in the process of implementing a new Education System that will operate directly from these Education web pages. If you are registered on the Foundation Certificate 2024/25, or are in your second year of the 2023/24 course, you will need to access your course from the old Education System. This you can do by clicking on the "My existing courses" tab below under the heading "My courses". Please note that you will need to be signed into your INSOL account in order to see this tile. Once you click on the "My existing courses tile", your course will display in the same way it used to on the old Education System. It is important to note that over the next few months all courses will be migrated across to the new platform. We will communicate any changes to the two Foundation Certificate groups prior to making any changes.<br /><br />

      Please also note that access to any courses that were presented in 2024 or before (with the exception of the 2024/25 and 2023/24 Foundation Certificate), will no longer be available after mid-February 2025. Candidates registered on these courses are requested to download all materials / certificates they require from the old Education System prior to mid-February 2025.
            </span>*/}
        <p className="text-brandMidBlue mb-4">Please note that access to any of our courses that were presented prior to 2025, is no longer possible.</p>
        <p className="text-brandMidBlue mb-4">Applications for a place on our courses must be made online using the online registration form for each course. This is the only manner in which applications on our courses can be made. If you have accessibility issues, please get in touch with Brenda Bennett at <a className="underline" href="mailto:brenda.bennett@insol.org">Brenda.Bennett@insol.org</a> who will be able to assist you.</p>
        <p className="text-brandMidBlue mb-4">If you encounter any difficulties accessing the course(s) on which you are currently enrolled, or require assistance enrolling on any of the courses that we offer, please get in touch with David Burdette (<a className="underline" href="mailto:david.burdette@insol.org">David.Burdette@insol.org</a>) or Brenda Bennett (<a className="underline" href="mailto:brenda.bennett@insol.org">Brenda.Bennett@insol.org</a>) who will be happy to assist you.</p>
        <p className="text-brandMidBlue">Please bookmark this page in order to stay up to date with exciting new courses that will soon be launched.</p>
        </div>
      </section>

      {/* My Courses */}
      <section className="courses py-8 lg:py-12">
        <header className="section__header">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
            <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">My courses</h1>
            {/*<div className="section__header-row mb-6 max-w-640">
              <span className="section__header-subtitle text-brandMidBlue">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</span>
            </div>*/}
          </div>
        </header>
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            
            {/*user && (
            <article className="relative p-6 text-white bg-gradient-to-b from-brandDarkBlue to-brandMidBlue">
              <div className="course__desc">
                <h3 className="course__title text-xl mb-4">My existing courses</h3>
                <span className="course__summary">Please click here to access any existing courses from 2024 or before that you may be registered on.</span>
              </div>
              <a href="/education/portal" className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</a>
            </article>
            )*/}

            {myApplications.map((course, index) => (
              <article key={index} className="relative p-6 text-white bg-gradient-to-b from-brandDarkBlue to-brandMidBlue">
                {course.status !== "Enrolled" && (<span className="absolute bg-brandRed -top-5 right-6 py-2 px-3"><strong>Application Status: </strong>{course.status}</span>)}
                <div className={`course__desc ${course.status === "Enrolled" ? "pb-6 mb-4" : ""}`}>
                  <h3 className="course__title text-xl mb-4">{course.courseTitle}</h3>
                  <span className="course__summary">{course.courseSummary}</span>
                </div>
                <div className="course__info">
                  {course.status === "Enrolled" && new Date(course.courseStartDate) > today && (
                  <div className="flex items-center mb-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-clock" viewBox="0 0 16 16">
                        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                      </svg>
                      <span>{`Course Starts in ${daysUntilCourseStarts(course.courseStartDate)} Days`}</span>
                  </div>
                  )}
                  {course.status === "Enrolled" && new Date(course.courseStartDate) < today && new Date(course.courseEndDate) > today && (
                  <div className="flex items-center mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-clock-fill" viewBox="0 0 16 16">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                    </svg>
                    <span>
                      {`Course Ends in ${
                        course.yearsToComplete === 2
                          ? daysUntilCourseStarts(course.courseEndDateYear2)
                          : daysUntilCourseStarts(course.courseEndDate)
                      } Days`}
                    </span>
                  </div>
                  )}
                </div>
                <Link to={`../course/${course.courseId}`} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
              </article>
            ))}
            
          </div>

          {!user && (
            <span className="border border-brandMidBlue bg-brandGrey p-10 text-brandMidBlue mt-10" style={{ display: 'block' }}>
              Please login to view and access your courses.
            </span>
          )}

          {/* If not applied to any courses */}
          {!myApplications && (
            <span className="border border-brandMidBlue bg-brandGrey p-10 text-brandMidBlue mt-10" style={{ display: 'block' }}>
              You are not enrolled on any courses. Please apply to a course below to get started.
            </span>
          )}
          {/* If not applied to any courses */}
        
        </div>
      </section>

      {/* All Courses */}
      <section className="courses py-8 lg:py-12 bg-brandGrey">
        <header className="section__header">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
            <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">All courses</h1>
            {/*<div className="section__header-row mb-6 max-w-640">
              <span className="section__header-subtitle text-brandMidBlue">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</span>
            </div>*/}
          </div>
        </header>
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

              {courses.map((course, index) => (
              <article key={course.courseId} className="relative p-6 text-white bg-gradient-to-b from-brandDarkBlue to-brandMidBlue">
                <div className="course__desc">
                  <h3 className="course__title text-xl mb-4">{course.courseTitle}</h3>
                  <span className="course__summary">{course.courseSummary}</span>
                </div>
                <Link to={`../course/${course.courseId}`} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
              </article>
              ))}

          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;